import { InitCookie } from '@patsnap/init-cookie';
import { getAgentSourceType } from './url';

export const SELF_ENTRY_CHANNEL = getAgentSourceType();

export const entryCookie = new InitCookie({
    entry_channel: SELF_ENTRY_CHANNEL,
});

export const initCookie = InitCookie;
